












































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import publicFunc from '../../common/util/publicFunc';
import { CspInquiry, Inquiry } from '@/http';
import { type } from '@/http/interface';
import { enums } from '@/common/enums';
import ListFilterPanel from '@/components/ListFilterPanel.vue';

export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        SearchPanel,
        DraggerImg,
    },
})
export default class SingleInquiry extends Vue {
    // 自适应表格列宽
    flexColumnWidth(str, tableData, flag = 'max') {
        // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
        // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
        // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
        str = str + '';
        let columnContent = '';
        if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
            return '140px';
        }
        if (!str || !str.length || str.length === 0 || str === undefined) {
            return;
        }
        if (flag === 'equal') {
            // 获取该列中第一个不为空的数据(内容)
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str].length > 0) {
                    // console.log('该列数据[0]:', tableData[0][str])
                    columnContent = tableData[i][str];
                    break;
                }
            }
        } else {
            // 获取该列中最长的数据(内容)
            let index = 0;
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str] === null) {
                    return;
                }
                const now_temp = tableData[i][str] + '';
                const max_temp = tableData[index][str] + '';
                if (now_temp.length > max_temp.length) {
                    index = i;
                }
            }
            columnContent = tableData[index][str];
        }
        // console.log('该列数据[i]:', columnContent)
        // 以下分配的单位长度可根据实际需求进行调整
        let flexWidth = 0;
        for (const char of columnContent) {
            if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                // 如果是英文字符，为字符分配8个单位宽度
                flexWidth += 9;
            } else if (char >= '\u4e00' && char <= '\u9fa5') {
                // 如果是中文字符，为字符分配15个单位宽度
                flexWidth += 16;
            } else {
                // 其他种类字符，为字符分配8个单位宽度
                flexWidth += 9;
            }
        }
        if (flexWidth < 160) {
            // 设置最小宽度
            flexWidth = 160;
        }
        // if (flexWidth > 250) {
        //   // 设置最大宽度
        //   flexWidth = 250
        // }
        return flexWidth + 10 + 'px';
    }
    public isDisabled: boolean = false;
    public publicFunc: any = publicFunc;
    public inquiryType = enums.inquiryType;
    public inquiryStatusType = enums.inquiryStatusType;
    public labelPosition: string = 'right';

    public expandType: boolean = false;
    public loading = false;
    public rePagin = false;
    public tabelData = [];
    public total = 0;
    public isActive: boolean = false;
    timeList = [];
    public datetimerange(value) {
        if (value) {
            this.searchValue.startTime = value[0];
            this.searchValue.endTime = value[1];
        } else {
            this.searchValue.startTime = null;
            this.searchValue.endTime = null;
        }
    }
    statusArr: any = [];
    public searchValue: any = {
        startTime: '',
        endTime: '',
        deliveryAddress: '',
        arrivalAddress: '',
        code: '',
        inquiryWay: '',
        statusListStr: '',
        winner: '',
        orderBy: '',
    };
    public tableData: Array<type.CspInquiryListItem> = [];
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public $refs: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        draggerImg: HTMLFormElement;
    };

    public toOrderId = '';

    public toOrder(id) {
        this.$router.push({
            path: '/addOrder',
            query: {
                inquiryId: id,
                type: 'inquiry',
            },
        });
    }

    //根据权限判断按钮显隐
    public dbb3: boolean = false;
    public dbz3: boolean = false;
    public dbs3: boolean = false;
    public dbbl3: boolean = false;
    public created() {
        let webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
        // let webMenus = sessionStorage.getItem('webMenus') ? sessionStorage.getItem('webMenus') : localStorage.getItem('webMenus');
        this.dbb3 = webMenus.includes('dbb3');
        this.dbz3 = webMenus.includes('dbz3');
        this.dbs3 = webMenus.includes('dbs3');
        this.dbbl3 = webMenus.includes('dbbl3');
    }
    public mounted() {
        this.$refs.draggerImg.imgdrager();
        if (this.$route.query.type === 'dashboard') {
            this.searchValue = {
                startTime: '',
                endTime: '',
                deliveryAddress: '',
                arrivalAddress: '',
                code: '',
                inquiryWay: '',
                statusListStr: '',
                winner: '',
                orderBy: '',
            };
            this.timeList = [];
            this.statusArr = ['3'];
            this.searchValue.statusListStr = '3';
            this.searchFunc();
            this.isActive = true;
        } else {
            if (sessionStorage.getItem('SingleInquiry_searchValue')) {
                this.searchValue = JSON.parse(sessionStorage.getItem('SingleInquiry_searchValue'));
                this.timeList = [this.searchValue.startTime, this.searchValue.endTime];
                this.statusArr = sessionStorage.getItem('SingleInquiry_statusArr')
                    ? JSON.parse(sessionStorage.getItem('SingleInquiry_statusArr'))
                    : [];

                this.searchPagin = sessionStorage.getItem('SingleInquiry_page')
                    ? JSON.parse(sessionStorage.getItem('SingleInquiry_page'))
                    : this.searchPagin;
                this.getInquiryList();
            } else {
                this.searchPagin = sessionStorage.getItem('SingleInquiry_page')
                    ? JSON.parse(sessionStorage.getItem('SingleInquiry_page'))
                    : this.searchPagin;
                this.getInquiryList();
            }
            this.isActive = sessionStorage.getItem('SingleInquiry_isActive') ? JSON.parse(sessionStorage.getItem('SingleInquiry_isActive')) : false;
        }
    }

    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'code':
                {
                    this.searchValue.orderBy = '1';
                }
                break;
            case 'inquiryWayStr':
                {
                    this.searchValue.orderBy = '2';
                }
                break;
            case 'creationTime':
                {
                    this.searchValue.orderBy = '3';
                }
                break;
            case 'carLength':
                {
                    this.searchValue.orderBy = '4';
                }
                break;
            case 'carriageWayStr':
                {
                    this.searchValue.orderBy = '5';
                }
                break;
            case 'preDeliveryTime':
                {
                    this.searchValue.orderBy = '6';
                }
                break;
            case 'priceEndTime':
                {
                    this.searchValue.orderBy = '7';
                }
                break;
            case 'statusStr':
                {
                    this.searchValue.orderBy = '8';
                }
                break;
            case 'vehicleType':
                {
                    this.searchValue.orderBy = '9';
                }
                break;
        }
        this.getInquiryList();
    }

    public toEdit(data) {
        sessionStorage.setItem('SingleInquiry_isActive', JSON.stringify(this.isActive));
        this.$router.push({
            path: '/addInquiry',
            query: {
                id: data.id,
                type: 'edit',
            },
        });
    }

    public getMore() {
        this.expandType = !this.expandType;
    }

    public async exportExcel() {
        this.searchValue.statusListStr = this.statusArr.join();
        let data = await Inquiry.Export(this.searchValue);
        // if (data && data.attachmentUrl) {
        //     window.open(data.attachmentUrl);
        // } else {
        //     this.$message.warning('导出失败!');
        // }
    }

    public getInquiryList() {
        this.loading = true;
        this.searchValue.statusListStr = this.statusArr.join();
        Inquiry.getList({
            ...this.searchValue,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        })
            .then((res) => {
                this.tableData = res.data;
                let skip = this.searchPagin.skip;
                this.tableData.map((item, index) => {
                    item.index = skip++ + 1;
                });
                this.total = res.total;
                this.loading = false;
                this.$refs.pagination.setNowPage(this.searchPagin.count);
                this.$refs.pagination.setPage(this.searchPagin.currentPage);
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    public searchFunc() {
        sessionStorage.setItem('SingleInquiry_searchValue', JSON.stringify(this.searchValue));
        sessionStorage.setItem('SingleInquiry_statusArr', JSON.stringify(this.statusArr));
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }

    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('SingleInquiry_page', JSON.stringify(pagin));
        this.getInquiryList();
    }

    public viewInquiry(item) {
        sessionStorage.setItem('SingleInquiry_page', JSON.stringify(this.searchPagin));
        sessionStorage.setItem('SingleInquiry_isActive', JSON.stringify(this.isActive));
        this.$router.push({
            path: '/InquiryDetail',
            query: {
                type: 'view',
                id: item.id,
            },
        });
    }
    public selectionRow = [] as any;
    public multipleSelection: any;
    handleSelectionChange(rows) {
        this.selectionRow = rows;
        if (rows.length > 1) {
            this.$refs.multipleTable.clearSelection();
            this.$refs.multipleTable.toggleRowSelection(rows.pop());
        }
        if (rows.length != 0) {
            this.toOrderId = rows[rows.length - 1].id;
            if (rows[0].statusStr == '招标成功') {
                this.isDisabled = false;
            } else {
                this.isDisabled = true;
            }
        }
    }
    @Watch('selectionRow')
    selectionRowCHange() {
        if (this.selectionRow.length == 0) {
            this.isDisabled = false;
        }
    }

    public toOrderPage() {
        if (this.selectionRow.length == 1) {
            this.$router.push({
                path: '/addOrder',
                query: {
                    inquiryId: this.toOrderId,
                    type: 'inquiry',
                },
            });
        } else {
            this.$message.warning('请选择一条招标成功的数据!');
        }
    }
    /** 单选配置 */
    /* start */
    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }

    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            //给每一行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
    toDetail(row, type) {
        sessionStorage.setItem('SingleInquiry_isActive', JSON.stringify(this.isActive));
        if (type == 1) {
            this.$router.push({
                path: '/InquiryDetail',
                query: {
                    id: row.id,
                    name: 'detail',
                },
            });
        } else if (type == 2) {
            this.$router.push({
                path: '/InquiryDetail',
                query: {
                    id: row.id,
                    name: 'banli',
                },
            });
        }
    }
    copAdd() {
        sessionStorage.setItem('SingleInquiry_isActive', JSON.stringify(this.isActive));
        if (this.selectionRow.length != 0) {
            this.$router.push({
                path: '/addInquiry',
                query: {
                    type: 'copy',
                    id: this.selectionRow[0].id,
                },
            });
        } else {
            this.$router.push({
                path: '/addInquiry',
                query: {},
            });
        }
    }
    // 删除询价单
    public dialogConfig2 = {
        title: '',
        show: false,
    };
    public dialogConfig3 = {
        title: '',
        show: false,
    };
    confirmClose2() {
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    confirmClose3() {
        this.dialogConfig3 = {
            title: '',
            show: false,
        };
    }
    confirmOk2() {
        Inquiry.DelInquiry(this.data1).then(() => {
            this.$message.success('询价单删除成功');
            this.getInquiryList();
        });
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    public data1: any = null;
    public handleDelete(data) {
        this.data1 = data;
        this.dialogConfig2 = {
            title: '删除询价单',
            show: true,
        };
        // this.$confirm('确认删除该询价单?', '询价单删除', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         Inquiry.DelInquiry(data).then(() => {
        //             this.$message.success('询价单删除成功');
        //             this.getInquiryList();
        //         });
        //     })
        //     .catch(() => {});
    }
    confirmOk3() {
        Inquiry.EndInquiry(this.data2).then(() => {
            this.$message.success('询价单终结成功');
            this.getInquiryList();
        });
        this.dialogConfig3 = {
            title: '',
            show: false,
        };
    }
    public data2: any = null;
    public handleFinal(data) {
        this.data2 = data;
        this.dialogConfig3 = {
            title: '终结询价单',
            show: true,
        };
        // this.$confirm('确认终结该询价单?', '询价单终结', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         Inquiry.EndInquiry(data).then(() => {
        //             this.$message.success('询价单终结成功');
        //             this.getInquiryList();
        //         });
        //     })
        //     .catch(() => {});
    }

    public handleCommand(command) {
        switch (command.command) {
            case 'delete':
                this.handleDelete(command.data);
                break;
            case 'final':
                this.handleFinal(command.data);
                break;
        }
    }

    beforeHandleCommand(data, command) {
        return {
            data: data,
            command: command,
        };
    }

    public colData = JSON.parse(localStorage.getItem('SingleInquiry'))
        ? JSON.parse(localStorage.getItem('SingleInquiry'))
        : [
              { title: '询价编号', isShow: true, disabled: false },
              { title: '发货企业', isShow: true, disabled: false },
              { title: '询价方式', isShow: true, disabled: false },
              { title: '发货地址', isShow: true, disabled: false },
              { title: '收货地址', isShow: true, disabled: false },
              { title: '所需车长', isShow: true, disabled: false },
              { title: '所需车数（车）', isShow: true, disabled: false },
              { title: '所需车型', isShow: true, disabled: false },
              { title: '承运方式', isShow: true, disabled: false },
              { title: '预计发货时间', isShow: true, disabled: false },
              { title: '报价截止时间', isShow: true, disabled: false },
              { title: '中标承运商', isShow: true, disabled: false },
              { title: '询价状态', isShow: true, disabled: false },
              { title: '发布时间', isShow: true, disabled: false },
          ];
    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('SingleInquiry', JSON.stringify(this.colData));
    }

    public resetSearchValue() {
        this.searchValue = {
            startTime: '',
            endTime: '',
            deliveryAddress: '',
            arrivalAddress: '',
            code: '',
            inquiryWay: '',
            statusListStr: '',
            winner: '',
            orderBy: '',
        };
        this.statusArr = [];
        this.timeList = [];
        this.$refs.multipleTable.clearSort();
        this.$refs.pagination.resetSize();
        this.$refs.pagination.handleSizeChange(10);
        this.searchFunc();
    }
}
